import React from 'react';
import { useTranslation } from 'react-i18next';

interface FormErrorMessageProps {
  message?: string;
}

const FormErrorMessage: React.FC<FormErrorMessageProps> = props => {
  const { message } = props;
  const { t } = useTranslation();

  return (
    <p className="text-red-2-dark text-base bg-red-3-light rounded-xl overflow-hidden p-3 text-center mt-10">
      {message || t('Please make sure all inputs are filled in and valid.')}
    </p>
  );
};

export default FormErrorMessage;
